// extracted by css-extract-rspack-plugin
export default {"overlay":"PostImage-overlay_W8F"};